/* RESPONSIBLE TEAM: team-workflows */
import type HandoffToSalesforceCase from 'embercom/models/operator/visual-builder/step/handoff-to-salesforce-case';
import StepConfig, { type StepConfigParams } from '../step';

export default class HandoffToSalesforceCaseConfiguration extends StepConfig {
  declare step: HandoffToSalesforceCase;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component: 'workflows/graph-editor/node-items/steps/handoff-to-salesforce-case',
      ...params,
    });
  }

  get alignment() {
    return 'left' as const;
  }
}
